import { render } from "./RevisionTable.vue?vue&type=template&id=610426cb&scoped=true"
import script from "./RevisionTable.vue?vue&type=script&lang=js"
export * from "./RevisionTable.vue?vue&type=script&lang=js"

import "./RevisionTable.vue?vue&type=style&index=0&id=610426cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610426cb"]])

export default __exports__